import React, { memo, useState } from 'react';
import { Pie, G2 } from '@ant-design/plots';

import { Typography, Radio } from 'antd';
// styles
import './style.scss';

import { useTranslation } from "react-i18next";

function HomePieChart() {
  const { t } = useTranslation();
  const [tab, setTab] = useState('day');
  const G = G2.getEngine('canvas');

  const data = {
    day: [
      {
        type: t('global.absenceTypes.no-medical'),
        value: 8,
      },
      {
        type: t('global.absenceTypes.medical'),
        value: 4,
      },
      {
        type: t('global.absenceTypes.sickness'),
        value: 12,
      },
    ],
    week: [
      {
        type: t('global.absenceTypes.no-medical'),
        value: 15,
      },
      {
        type: t('global.absenceTypes.medical'),
        value: 4,
      },
      {
        type: t('global.absenceTypes.sickness'),
        value: 31,
      },
    ],
    month: [
      {
        type: t('global.absenceTypes.no-medical'),
        value: 20,
      },
      {
        type: t('global.absenceTypes.medical'),
        value: 30,
      },
      {
        type: t('global.absenceTypes.sickness'),
        value: 44,
      },
    ],
    semester: [
      {
        type: t('global.absenceTypes.no-medical'),
        value: 64,
      },
      {
        type: t('global.absenceTypes.medical'),
        value: 40,
      },
      {
        type: t('global.absenceTypes.sickness'),
        value: 80,
      },
    ],
  };

  const config = {
    appendPadding: 10,
    data: data[tab],
    color: ['#568DF6', '#60779D', '#EBB917'],
    angleField: 'value',
    colorField: 'type',
    radius: 0.75,
    legend: false,
    label: {
      type: 'spider',
      labelHeight: 40,
      formatter: (data, mappingData) => {
        const group = new G.Group({});
        group.addShape({
          type: 'circle',
          attrs: {
            x: 0,
            y: 0,
            width: 40,
            height: 50,
            r: 5,
            fill: mappingData.color,
          },
        });
        group.addShape({
          type: 'text',
          attrs: {
            x: 10,
            y: 8,
            text: `${data.type}`,
            fill: '#ffffff',
          },
        });
        group.addShape({
          type: 'text',
          attrs: {
            x: 0,
            y: 25,
            text: data.value,
            fill: '#ffffff',
            fontWeight: 700,
          },
        });
        return group;
      },
    },
    interactions: [
      {
        type: 'element-selected',
      },
      {
        type: 'element-active',
      },
    ],
  };

  return (
    <div className="absent-reasons">
      <Typography.Title level={3} className="heading-title">
        { t('absences.absencesReason')}
      </Typography.Title>
      <div className="tab-container">
        <Radio.Group
          options={[
            { label: t("absences.day") , value: "day" },
            { label: t("absences.week") , value: "week" },
            { label: t("absences.month"), value: "month" },
            { label: t("absences.semester"), value: "semester" },
          ]}
          buttonStyle="solid"
          optionType="button"
          value={tab}
          onChange={e => setTab(e.target.value)}
          className="tab-container--tab"
        />
      </div>
      <div className="bar-chart">
        <Pie {...config} height={260} />
      </div>
    </div>
  );
}

HomePieChart.defaultProps = {};
HomePieChart.propTypes = {};

export default memo(HomePieChart);
